<template>
  <div>
    <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options">
      <div v-if="props.row.nir" slot="nir" slot-scope="props">
        <a href="#" @click.prevent="fiche(props.row)">{{ props.row.nir }}</a>
      </div>
      <div slot="source" slot-scope="props" v-if="props.row.source === 'assure'">
          <span style="color: red;">Assuré</span>
      </div>
      <div v-else>
        <span style="color: blue;">Bénéficiaire</span>
      </div>
    </v-server-table>
  </div>
</template>

<script>
  import {getUser} from "@/utils/auth";

  export default {
    name: "AssureTable",
    props: ["tableEntry"],
    data() {
      let self = this;
      return {
        url: '',
        columns: ["nir", "nom", "prenom", "siren","source"],
        options: {
          headings: {
            nir: "NIR",
            nom: "Nom",
            prenom: "Prénom",
            siren: "SIREN",
            type : "source"
          },
          perPage: 10,
          filterable: false,
          perPageValues: [10, 25, 50],
          orderBy: {ascending: true},
          requestFunction: function (data) {
            self.url = '/espaceGestion/assures/rechercheAssureOrBeneficiaire'
            data["nir_criteria"] = self.tableEntry.nir_criteria;
            data["nom_criteria"] = self.tableEntry.nom_criteria;
            data["prenom_criteria"] = self.tableEntry.prenom_criteria;
            data["dossier_criteria"] = self.tableEntry.dossier_criteria;
            data["siren_criteria"] = self.tableEntry.siren_criteria;
            data["email_criteria"] = self.tableEntry.email_criteria;
            data["email_criteria"] = self.tableEntry.email_criteria;
            data["source"] = self.tableEntry.source;
            data["noSearch"] = self.$parent.noSearch;
            self.$store.commit("IS_LOADING", true);

            return axios.get(self.url, {
              params: data
            })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          }
        }
      };
    },
    methods: {
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      fiche(data) {
        let nir = data.nir

        data.oag = data.oag ? data.oag : '92063';
        data.oap = data.oap ? data.oap : '92063';

        let user = getUser();
        let userOags = user.profil_active[0].oags.map(oag => oag.code);
        let userOaps = user.profil_active[0].oaps.map(oap => oap.code);
        if ((userOags.indexOf(data.oag) > -1 && userOaps.indexOf(data.oap) > -1) || data.source === 'beneficiaire') {
          this.$router.push({
            path: "/espace-gestion/assures/fiche/" + nir,
            query: {
              do: this.tableEntry.dossier_criteria,
              ns: this.tableEntry.nir_criteria,
              no: this.tableEntry.nom_criteria,
              pr: this.tableEntry.prenom_criteria,
              email: this.tableEntry.email_criteria,
              siren: this.tableEntry.siren_criteria,
              source: this.tableEntry.source,
              oag: data.oag,
              oap: data.oap
            }
          });
        } else {
          this.$swal({
            position: "top",
            type: "warning",
            title: "Attention !",
            text: 'Vous n\'avez pas les habilitations pour consulter cette fiche assuré',
            showConfirmButton: false,
            timer: 3000
          })
        }
      },
    }
  }
</script>

<style scoped>
  .VueTables__search-field input {
    width: 240px !important;
  }
</style>
